import user from './user';

export default function() {
  user.logout();
  window.location = '/';
  return;
}
